module.exports = __webpack_public_path__ + "static/img/bg-chronology.8f6568e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-chronology.jpg
// module id = F1zG
// module chunks = 0